<template>
  <div class="col-md-12">
    <Form :validation-schema="schema" @submit="requestLink">
      <Header/>
      <div class="header-group">
        <h1><img alt="" src="@/assets/img/underline.png"> CRÉER UN COMPTE</h1>
      </div>

      <div class="register-rgpd mb-4">
        Saisissez votre adresse email pour recevoir un lien vers le formulaire d'inscription.
      </div>

      <div class="form-group">
        <Field
            autocomplete="email"
            class="form-control"
            name="email"
            placeholder="Email*"
            type="email"
            @input="errorMessage = ''"
        />
        <ErrorMessage class="error-feedback" name="email"/>
        <div v-if="errorMessage" class="error-feedback">
          {{ errorMessage }}
        </div>
      </div>

      <div class="form-group">
        <button :disabled="loading" class="btn btn-primary btn-block">
          <span v-show="loading" class="spinner-border spinner-border-sm"></span>
          Recevoir le lien d'inscription
        </button>
      </div>

      <div class="home-login-group mt-0 mb-0 px-0">
        <div class="home-login-group-info">Vous avez déjà un compte ?</div>
        <div class="home-login-group-href">
          <router-link :to="{ name: 'public-login'}" class="nav-link">Se connecter</router-link>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import Header from "./Header.vue";
import AuthApi from "@/api/AuthApi";
import RouteEnum from "@/router/RouteEnum";

export default {
  name: "RequestEmailToken",
  components: {
    Form,
    Field,
    ErrorMessage,
    Header,
  },
  data() {
    return {
      loading: false,
      errorMessage: "",
      schema: yup.object().shape({
        email: yup
            .string()
            .required("L'email est nécessaire")
            .email("L'email est invalide")
            .max(50),
      }),
    };
  },
  methods: {
    requestLink(values) {
      this.loading = true;
      this.errorMessage = "";

      AuthApi.requestSignUpEmailToken(values.email)
          .then(() => {
            this.$router.push({
              name: RouteEnum.REGISTER_SUCCESS,
              query: {
                step: "email-requested",
                email: values.email,
              }
            });
          })
          .catch((error) => {
            this.errorMessage = error.response?.data?.message || "Une erreur est survenue";
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>
